import React, { useState } from "react";
import { Tab } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import { useSSR, useTranslation } from "react-i18next";
import PageDemandeTransfert from "../Transfert/PageDemandeTransfert";
import PageListDemande from "../Transfert/PageListDemande";
import { useLocation, useNavigate } from "react-router-dom";
import DemandeTransfert from "../../Components/TransfertArticles/DemandeTransfert";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  selectedAutorisations,
  SelectedOrganisation,
} from "../../_App/Redux/Slices/Auth/authSlice";
import ApproverTransfert from "../../Components/TransfertArticles/ApproverTransfert";
import ApproverTransfertSociete from "../../Components/TransfertArticles/ApproverTransfertSociete";
import NombreLivraison from "../../Components/TransfertArticles/NombreLivraison";
import ListTransfertCreeSociete from "../../Components/TransfertArticles/ListTransfertCreeSociete";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import { resetPagination } from "../../_App/Redux/Slices/transferArticle/transferArticleSlice";

export default function DistributionArticle() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showDemande, setshowDemande] = useState(false);
  const selectedOrganisation = useAppSelector(SelectedOrganisation);
  const autorisations = useAppSelector(selectedAutorisations);
  const location = useLocation();
  const pathParts = location.pathname.split("/");
  const parametrage = useAppSelector(parametrageCaisse);
  const dispatch = useAppDispatch();

  const defaultkey = pathParts[2];
  const etatini = pathParts[3];
  const [keyselected, setSelectedkey] = useState(
    defaultkey || "Reception-distribution",
  );

  const ResetPagination = async () => {
    // Execute the function with () to trigger the reducer
    dispatch(resetPagination());
  };
  return (
    <>
      <div className="d-flex justify-content-end mb-3 mt-5">
        <button
          className=" btn btn-primary-app col-2"
          onClick={() => setshowDemande(true)}
        >
          {t("Reservation d'article")}
        </button>
        <button
          className=" btn btn-primary-app col-2"
          onClick={() => navigate("/DistributionParDepots")}
        >
          {t("sortie inter-dépôts")}
        </button>
        <button
          className=" btn btn-primary-app col-2"
          onClick={() => navigate("/DistributionParMagasin")}
        >
          {t("sortie inter-magasin")}
        </button>
        <button
          className=" btn btn-primary-app col-2"
          onClick={() => navigate("/DistributionParSociete")}
        >
          {t("sortie societe vers magasin")}
        </button>
      </div>
      <div className="card">
        <div className="card-body">
          <Tab.Container
            id="tabs"
            defaultActiveKey={keyselected}
            onSelect={ResetPagination}
            mountOnEnter={true} // Ne charge le contenu qu'au clic
            unmountOnExit={true}
          >
            <Nav variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="Reception-distribution">
                  {t("Réception magasin ") + selectedOrganisation?.nom}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Distribution-Cree">
                  {t("Sortie  magasin ") + selectedOrganisation?.nom}
                </Nav.Link>
              </Nav.Item>
              {autorisations?.CAN_VIEW_SOCIETE_SORTIE && (
                <Nav.Item>
                  <Nav.Link eventKey="Reception-distribution-societe">
                    {t("Réception ") + (parametrage?.Desc_Societe || "Societe")}
                  </Nav.Link>
                </Nav.Item>
              )}
              {autorisations?.CAN_VIEW_SOCIETE_SORTIE && (
                <Nav.Item>
                  <Nav.Link eventKey="Distribution-Societe">
                    {t("Sortie ") + (parametrage?.Desc_Societe || "Societe")}
                  </Nav.Link>
                </Nav.Item>
              )}
              {autorisations?.CAN_VIEW_NOMBRE_LIVRAISON && (
                <Nav.Item>
                  <Nav.Link eventKey="Nombre-Livraison">
                    {t("Nombre Livraison ")}
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>

            {/* Ajoute cette partie */}
            <Tab.Content>
              <Tab.Pane eventKey="Reception-distribution">
                <PageDemandeTransfert />
              </Tab.Pane>
              <Tab.Pane eventKey="Distribution-Cree">
                <ApproverTransfert
                  key="org"
                  statusini="org"
                  etatini={etatini}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="Reception-distribution-societe">
                <ListTransfertCreeSociete statusini={"societe"} />
              </Tab.Pane>
              <Tab.Pane eventKey="Distribution-Societe">
                <ApproverTransfertSociete
                  key="societe"
                  statusini="societe"
                  etatini={etatini}
                />
              </Tab.Pane>

              <Tab.Pane eventKey="Nombre-Livraison">
                <NombreLivraison key="NbrL" />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
      {showDemande && (
        <DemandeTransfert
          setShowModal={setshowDemande}
          ShowModal={showDemande}
        />
      )}
    </>
  );
}
